<span style="white-space:normal" ng-bind-html="$ctrl.item.text|cHighlight:$ctrl.highlight"></span>
<span style="white-space:normal" ng-if="$ctrl.item.badgeText" title="{{$ctrl.title(item)}}" class="badge" ng-bind-html="$ctrl.item.badgeText|cHighlight:$ctrl.highlight"></span>

<div ng-if="$ctrl.item.additionalInfo && $ctrl.item.additionalInfo.length > 0" class="additional-info">
    <div ng-repeat="info in $ctrl.item.additionalInfo track by $index" ng-bind-html="info|cHighlight:$ctrl.highlight"></div>
</div>